import Vue from "vue";
import Vuetify, {
    VApp,
    VNavigationDrawer,
    VToolbar,
    VFadeTransition
} from "vuetify/lib";
import i18n       from "@/plugins/i18n";
import { Ripple } from "vuetify/lib/directives";
import "vuetify/src/stylus/app.styl";

let en = i18n.messages["en"];
let ru = i18n.messages["ru"];

Vue.use(Vuetify, {
    iconfont: "md",
    lang: {
        locales: { en, ru },
        current: "ru"
    },
    components: {
        VApp,
        VNavigationDrawer,
        VToolbar,
        VFadeTransition
    },
    directives: {
        Ripple
    }
});
